import React from 'react';
import { paginate } from '../utils/paginate';
const defaultRowsPerPage = 5;
const defaultPage = 0;
const rowsPerPageOptions = [5, 10, 20, 50];
const totalRowCount = 500;
export const useDataTablePagination = ({ data }) => {
    const [page, setPage] = React.useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage);
    const rows = paginate({ page, pageSize: rowsPerPage, array: data });
    return {
        page,
        onPageChange: setPage,
        rowsPerPage,
        onRowsPerPagePageChange: setRowsPerPage,
        rows,
        rowsPerPageOptions,
        totalRowCount,
    };
};
